import React, { useCallback, useState } from 'react'
import dynamic from 'next/dynamic'
import RecommendedReads from '../../../shared/Rewrite/BrandPages/RecommendedReads'
import { howItWorksData } from './consts'
import BrandSection from '../../../shared/Rewrite/BrandPages/BrandSection'
import Modal from '../../../shared/Modal'
import KindOfDebt from './KindOfDebt'
import BottomSection from '../../../shared/Rewrite/BrandPages/BottomSection'
import Section from '../../../shared/BrandPages/Section'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'
import { APPLY_FDR_URL } from '../../../../common/constants'
import { heroVariationData } from './consts'
import Content from '../../../shared/BrandPages/Content'
import HeroSection from '../../../shared/Rewrite/BrandPages/HeroSection'
import { useTrustMarkers } from 'src/common/trust-markers'
import { numberFormat } from 'src/common/utils'

const FiveSteps = dynamic(() => import('./FiveSteps'))

const HowItWorks = ({ showScheduleACallButton }) => {
  const [showModal, setShowModal] = useState(false)
  const { getTrustMarkerById } = useTrustMarkers()
  const trustPilot = getTrustMarkerById('truspilot')
  const handleModalOpen = useCallback(() => {
    setShowModal(true)
    document.body.style.overflow = 'hidden'
  }, [setShowModal])

  const handleModalClose = useCallback(() => {
    setShowModal(false)
    document.body.style.overflow = 'unset'
  }, [setShowModal])
  const {
    seo,
    heroData,
    brandData,
    kindOfDebt,
    fiveSteps,
    recommendedReadsData,
    bottomSectionData,
  } = howItWorksData

  return (
    <Content>
      <WithSeoOverrides {...seo} />
      <Section classNames="pb-0 pt-0">
        <HeroSection
          {...heroData}
          provenResultsBelowTheFold={heroVariationData.provenResults}
          contentClassName="bottom-125 md:bottom-88 lg:bottom-0 lg:pt-16 lg:ml-4 mx-4 p-6"
          imgClassName="xl:object-left-0.9 object-left-0.7"
          provenResultsClassName="lg:hidden pt-44"
          imgContainerClassName="lg:h-600"
          richTextClassName="max-w-130 lg:max-w-none"
          showNewTrustpilot
          trustPilotInfo={{
            rating: Number(trustPilot?.rating),
            totalReviews: numberFormat(Number(trustPilot?.totalReview)),
            link: trustPilot?.link,
            color: '#33b083',
          }}
          showScheduleACallButton={showScheduleACallButton}
        />
      </Section>
      <Section classNames="bg-blue-base-white">
        <BrandSection
          {...brandData}
          onClick={handleModalOpen}
          childClassName="order-3 lg:order-last pb-6 lg:pb-0 pt-10 lg:pt-0"
          button={{
            name: 'Get your free evaluation',
            href: APPLY_FDR_URL(),
            isLeadCta: true,
          }}
        >
          <FiveSteps
            steps={fiveSteps}
            primaryBtnClassName="bg-red-850 text-white"
            primaryBtnName="Get debt help now"
          />
        </BrandSection>
        <p className="mt-5 px-4 text-center text-13 text-gray-235 lg:mt-0 lg:pl-28 lg:text-left xl:pl-32">
          <sup> 1 </sup> Images shown above are for illustrative purposes only.
          Individual results are not typical and will vary.
        </p>
      </Section>
      <Section classNames="pt-0 pb-0">
        <RecommendedReads data={recommendedReadsData} />
      </Section>
      <Section classNames="pb-0 pt-0">
        <BottomSection {...bottomSectionData} />
      </Section>
      {showModal ? (
        <Modal
          bodyClassName="mb-4 mt-9"
          onClose={handleModalClose}
          open={showModal}
          className="w-72 lg:w-105"
          hasDistanceFromTop={true}
        >
          <KindOfDebt data={kindOfDebt} />
        </Modal>
      ) : null}
    </Content>
  )
}

export default HowItWorks
